const EnvelopIcon = (props) => (
  <svg
    width={80}
    height={70}
    viewBox='0 0 80 70'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21.985 60.8945C18.4674 60.8945 14.9498 57.8498 13.191 56.5449C4.39699 50.4555 1.7588 48.2807 0 46.9758V65.2441C0 67.6459 1.96903 69.5938 4.39699 69.5938H39.5729C42.0009 69.5938 43.9699 67.6459 43.9699 65.2441V46.9758C42.2111 48.2807 39.5729 50.4555 30.7789 56.5449C29.0201 57.8498 25.5025 60.8945 21.985 60.8945ZM39.5729 34.7969H4.39699C1.96903 34.7969 0 36.7447 0 39.1465V41.3213C3.51759 43.9311 3.07789 43.9311 15.8292 53.0652C17.1483 53.9352 19.7865 56.5449 21.985 56.5449C24.1834 56.5449 26.8216 53.9352 28.1407 53.5002C40.892 44.366 40.4523 44.366 43.9699 41.7563V39.1465C43.9699 36.7447 42.0009 34.7969 39.5729 34.7969ZM74.7488 21.748H30.7789C28.351 21.748 26.3819 23.6959 26.3819 26.0977V30.4473H39.5729C44.1362 30.4473 47.8983 33.9025 48.327 38.3065L48.3669 38.2766V56.5449H74.7488C77.1768 56.5449 79.1458 54.5971 79.1458 52.1953V26.0977C79.1458 23.6959 77.1768 21.748 74.7488 21.748ZM70.3519 39.1465H61.5579V30.4473H70.3519V39.1465ZM21.985 26.0977C21.985 21.3009 25.9299 17.3984 30.7789 17.3984H61.5579V4.34961C61.5579 1.94781 59.5888 0 57.1609 0H13.191C10.763 0 8.79398 1.94781 8.79398 4.34961V30.4473H21.985V26.0977Z'
      fill='#F00909'
    />
  </svg>
);
export default EnvelopIcon;
